export const setGlobalErrorSnackbarMessage = (message, severity) => ({
    type: 'SET_GLOBAL_ERROR_SNACKBAR_MESSAGE',
    payload: { message, severity }
  });
  
  export const closeGlobalErrorSnackbar = () => ({
    type: 'SET_GLOBAL_ERROR_SNACKBAR_MESSAGE',
    payload: { message: null, severity: 'info', open: false }
  });